/* RESPONSIBLE TEAM: team-automation-foundations */
import IntercomRoute from 'embercom/routes/base/intercom-route';
import { inject as service } from '@ember/service';

export default class CustomerSupportFinAiAgentRoute extends IntercomRoute {
  @service customReportsService;

  beforeModel() {
    this.customReportsService.routeToOverviewPage();
  }
}
